import { styled } from 'styled-components';
export const Wrapper = styled.div `
  display: grid;
  grid-template-columns: repeat(${({ $numberOfColumns }) => $numberOfColumns}, 1fr);
  border: 1px solid ${({ theme, $disabled }) => ($disabled ? theme.colors.grey05_3 : theme.colors.grey30_1)};
  border-radius: 8px;
  overflow: hidden;

  &:focus-within {
    ${({ theme }) => theme.shadows.focus}
    outline: 0;
  }
`;
export const LoaderSlot = styled.div `
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
`;
